import { Disclosure } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'
const { Button: DisclosureButton, Panel: DisclosurePanel } = Disclosure;

const faqs = [
    {
        question: "What's an AI Copywriter?",
        answer: "An AI copywriter, like CopyBuddy, is your on-call expert for crafting engaging email copy. Just feed it details about your offer and the pain points it solves, and it delivers top-notch content."
    },
    {
        question: "Why should I use an AI Email Writer like CopyBuddy?",
        answer: "Our AI email writer helps you overcome writer's block by generating creative and persuasive emails. It’s the perfect tool when you know your message but can't find the right words, making your email outreach more effective."
    },
    {
        question: "Can CopyBuddy generate different variations of the same email?",
        answer: "Yes, CopyBuddy excels in A/B testing, allowing you to generate multiple unique email versions from the same initial details. This feature helps you pinpoint the most effective content for engaging your audience."
    },
    // {
    //     question: "Is CopyBuddy free to try?",
    //     answer: "Absolutely! Try our AI email writer with 3 free credits—no payment info needed upfront. This allows you to test drive our best AI email writer and see how it enhances your email campaigns."
    // },
    {
        question: "What exactly is a credit?",
        answer: "A credit with CopyBuddy, your dedicated email writer generator, lets you create one tailored email. With 100 credits each month, you can explore various content strategies to maximize your impact."
    },
    {
        question: "Do credits expire at the end of the month?",
        answer: "Yes, to keep your content fresh and engaging, your credits refresh every month. Any unused credits expire, so you start each month with a clean slate for your email marketing campaigns."
    },
    {
        question: "How does CopyBuddy help streamline email marketing campaigns?",
        answer: "CopyBuddy, the best AI copywriter, automates the creative process. Just specify your target audience, benefits, and call to action, and receive polished, ready-to-send emails. This streamlines your campaign setup and ensures consistent communication quality."
    },
]


export default function Faq() {
    return (
        <div className="mx-auto max-w-7xl px-6 pt-32 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-lg font-semibold leading-8 tracking-tight text-custom-orange">Frequently asked questions</h2>
        </div>
                <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
                    <dl className="space-y-6 divide-y divide-gray-900/10">
                        {faqs.map((faq) => (
                            <Disclosure as="div" key={faq.question} className="pt-6">
                                {({ open }) => (
                                    <>
                                        <dt>
                                            <DisclosureButton className="flex w-full items-start justify-between text-left text-gray-900">
                                                <span className="text-base font-semibold leading-7">{faq.question}</span>
                                                <span className="ml-6 flex h-7 items-center">
                                                    {open ? (
                                                        <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                                                    ) : (
                                                        <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                                                    )}
                                                </span>
                                            </DisclosureButton>
                                        </dt>
                                        <DisclosurePanel as="dd" className="mt-2 pr-12">
                                            <p className="text-base leading-7 text-gray-600">{faq.answer}</p>
                                        </DisclosurePanel>
                                    </>
                                )}
                            </Disclosure>
                        ))}
                    </dl>
                </div>
        </div>
    )
}